import { render, staticRenderFns } from "./GetLs.vue?vue&type=template&id=2c735245&"
import script from "./GetLs.vue?vue&type=script&lang=js&"
export * from "./GetLs.vue?vue&type=script&lang=js&"
import style0 from "./GetLs.vue?vue&type=style&index=0&id=2c735245&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports